import { IndirectTaxFilingsHelper } from '../helpers';
import { IIndirectTaxFilingDetail } from '../types';

interface IndirectTaxFilingDetailMetadataLineProps {
  filing: IIndirectTaxFilingDetail;
}

const IndirectTaxFilingDetailMetadataLine = ({
  filing,
}: IndirectTaxFilingDetailMetadataLineProps) => {
  const parts = [
    filing.jurisdiction,
    filing.filingPeriod,
    IndirectTaxFilingsHelper.getFilingFrequencyName(filing.filingFrequency),
    `Due ${filing.dueDate}`,
  ].filter(Boolean);

  return (
    <div>
      {parts.map((part, idx) => (
        <span
          key={idx}
          className="inline-flex items-center txt-extra-small-regular text-text-secondary"
        >
          {part}
          {idx < parts.length - 1 && (
            <span className="mx-xs mt-xs size-1 bg-text-quaternary rounded-full inline-block"></span>
          )}
        </span>
      ))}
    </div>
  );
};

export { IndirectTaxFilingDetailMetadataLine };
